import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.split";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import * as Data from "../data";

var DocuwareHelper =
/*#__PURE__*/
function () {
  function DocuwareHelper() {
    _classCallCheck(this, DocuwareHelper);
  }

  _createClass(DocuwareHelper, [{
    key: "DownloadFile",
    value: function DownloadFile(docId) {
      Data.Files.DownloadFile(docId).then(function (response) {
        this.ShowFile(response.data);
      }.bind(this));
    }
  }, {
    key: "ShowFile",
    value: function ShowFile(data) {
      if (data.fileBase64 != null) {
        var base64 = data.fileBase64.split(";base64,")[1];
        var filetype = data.fileBase64.split(";base64,")[0];
        var byteCharacters = atob(base64);
        var byteArrays = [];
        var sliceSize = 512;

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
          var byteNumbers = new Array(slice.length);

          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, {
          type: filetype
        });

        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, data.fileName);
        } else {
          var link = document.createElement("a");

          if (link.download !== undefined) {
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", data.fileName);
            link.style = "visibility:hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      }
    }
  }, {
    key: "ToBase64",
    value: function () {
      var _ToBase = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(file) {
        var toBase64;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                toBase64 = function toBase64(file) {
                  return new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);

                    reader.onload = function () {
                      return resolve(reader.result);
                    };

                    reader.onerror = function (error) {
                      return reject(error);
                    };
                  });
                };

                _context.next = 3;
                return toBase64(file);

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function ToBase64(_x) {
        return _ToBase.apply(this, arguments);
      }

      return ToBase64;
    }()
  }]);

  return DocuwareHelper;
}();

export default new DocuwareHelper();